const Utils = {

	getClosest: () => {

	},

	mqMatches(width)
	{
		const mqList = window.matchMedia(`(max-width: ${width}px)`);
		return mqList.matches;
	},

	debounce(func, timeout = 300) {
		let timer;
		return (...args) => {
			clearTimeout(timer);
			timer = setTimeout(() => { func.apply(this, args); }, timeout);
		};
	}
};

export default Utils;